<template>
  <div class="mianv" v-if="isTs">
    <div class="title-wrapper">
      <div class="title-text">特色数据
        <p class="subtitle-t"  @click="throttleclickTSSJ(0)"></p>
        <img class="warn-tip-gray-gx" @click="throttleclickTSSJ(0)"
          src='@/assets/warn-tip-gray.png'/>
      </div>
      <span class="desc-r"  @click="clickMore" >更多</span>
      <img src="@/assets/right-arrow-gray.png"
          alt=""
          class="right-arrow"/>
    </div>
    <div class="ts-mid-tag">
      <div class="ts-tabs-mid-wrapper">
        <div v-for="(chart, index) in ['近1年','近3年','近5年']"
          :key="index"
          @click="updateChart('typeIndex', index)"
          :class="[typeIndex === index ? 'stab' : 'tab']"
        >
          <div class="tabs-ts-mid-item-text">
            {{ chart }}
          </div>
        </div>
      </div>
    </div>
    <div class="data-wrapper">
      <div class="leftv">
        <div class="item-bac" v-for="(item,index) in mainlist" :key="index"
        @click="throttleclickTSSJ(index)">
          <div class="item-value">{{item.value}}</div>
          <div  class="item-wrapper">
            <span class="item-text">{{item.text}}</span>
          </div>
      </div>
      </div>
      <div class="rightv">
        <div class="item-rank" v-for="(itemrank,index) in rankList" :key="index">
          <div class="norankdata" v-if="itemrank.rank >= 5"> 暂无排行数据 </div>
          <div  v-for="(item,indexrank) in [0,1,2,3]" :key="indexrank" class="itemClass">
            <div class="rank-view" v-if="itemrank.rank === indexrank">
              <div v-if="itemrank.need" class="rank-cont-ab">{{itemrank.content}}</div>
              <div v-else class="rank-cont">{{itemrank.content}}</div>
              <div class="rank-cont-w">aa</div>
              <div class="rank-arr"> <img class="rank_a"
                    src='@/assets/rank_a.png'/></div>
              <div class="rank-line-r" :style="getlinsyl(indexrank)"></div>
            </div>
            <div class="rank-view" v-else>
              <div class="rank-cont-w">aa</div>
              <div class="rank-arr"> <div class="rank_a"/></div>
              <div class="rank-line" :style="getlinsyl(indexrank)"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ts-empty" v-if="ShowEmpty">
      <p class="ts-text">暂无数据</p>
    </div>
  </div>
</template>

<script>
import StoreManger from '@/utils/FundHQJHManger';
import JSTool from '@/base/JSTool';
import { numeral } from '@fund/basic-lib';
import { throttle } from '@fund/basic-lib/dist/lib/function';
import {
  detailPushPage,
} from '@/utils/nativeBridge';

export default {
  name: 'FundFeatures',
  components: {
  },
  data() {
    return {
      nativeData: {},
      fundCode: '',
      fundType: '',
      // 数据类型索引
      typeIndex: 0,
      isTs: true,
      rankList: [
      ],
      mainlist: [],
      YieldStatementShow: false,
      ShowEmpty: false,
      alertContentArr: [
        {
          title: '最大回撤',
          content: '表示每承受一单位风险，预期可以拿到多少超额收益。\n指标越大越好。夏普比率越大则基金性价比越高。',
        },
        {
          title: '夏普比率',
          content: '表示基金净值从最高到最低的下降幅度。指标越小越好。\n最大回撤越大则风险控制能力越差。',
        },
        {
          title: '波动率',
          content: '表示收益率变化程度的指标，更直观地表述就是风险。\n指标越小越好。波动率越大则风险也越高。',
        },
      ],
    };
  },
  created() {
  },
  mounted() {},
  methods: {
    getlinsyl(index) {
      if (index === 0) {
        return 'border-radius: 100px 0 0 100px';
      }
      if (index === 3) {
        return 'border-radius: 0 100px 100px 0';
      }
      return 'border-radius: 0 0 0 0';
    },
    mainQueryError() {
      this.$refs.Module.showMainError();
    },
    render() {
      this.nativeData = this.$store.state.native.fund;
      this.fundCode = this.nativeData.fundCode;
      this.fundType = this.nativeData.fundType;
      if (this.$refs.Module) {
        this.$refs.Module.start();
      }
      this.fetchCache();
      this.comfigureRank();
    },
    comfigureRank3n() {
      const fundinfo = StoreManger.getFundTSSJ();
      if (fundinfo) {
        const {
          STDDEV_3NRANK,
          STDDEV_3NFSC,
          SHARP_3NRANK,
          SHARP_3NFSC,
          MAXRETRA_3NRANK,
          MAXRETRA_3NFSC,
        } = fundinfo;

        let bdrank = 5;
        let bdranktip = '';

        let xprank = 5;
        let xpranktip = '';

        let hcrank = 5;
        let hcranktip = '';

        if (STDDEV_3NFSC === '1') {
          bdrank = 3;
          bdranktip = '波动很小';
        }
        if (SHARP_3NFSC === '1') {
          xprank = 3;
          xpranktip = '性价比很高';
        }
        if (MAXRETRA_3NFSC === '1') {
          hcrank = 3;
          hcranktip = '回撤很低';
        }

        if (STDDEV_3NRANK !== '--' && STDDEV_3NFSC !== '--') {
          const descConfig = ['波动较大', '波动尚可', '波动较低', '波动很小'];
          const index = (parseFloat(STDDEV_3NRANK) / parseFloat(STDDEV_3NFSC));
          if (index <= 0.25) {
            bdrank = 3;
            bdranktip = `${descConfig[bdrank]}`;
          } else if (index <= 0.5 && index > 0.25) {
            bdrank = 2;
            bdranktip = `${descConfig[bdrank]}`;
          } else if (index <= 0.75 && index > 0.5) {
            bdrank = 1;
            bdranktip = `${descConfig[bdrank]}`;
          } else if (index <= 1 && index > 0.75) {
            bdrank = 0;
            bdranktip = `${descConfig[bdrank]}`;
          }
        }

        if (SHARP_3NRANK !== '--' && SHARP_3NFSC !== '--') {
          const descConfig = ['性价比较低', '性价比尚可', '性价比较高', '性价比很高'];
          const index = parseFloat(SHARP_3NRANK) / parseFloat(SHARP_3NFSC);
          if (index <= 0.25) {
            xprank = 3;
            xpranktip = `${descConfig[xprank]}`;
          } else if (index <= 0.5 && index > 0.25) {
            xprank = 2;
            xpranktip = `${descConfig[xprank]}`;
          } else if (index <= 0.75 && index > 0.5) {
            xprank = 1;
            xpranktip = `${descConfig[xprank]}`;
          } else if (index <= 1 && index > 0.75) {
            xprank = 0;
            xpranktip = `${descConfig[xprank]}`;
          }
        }

        if (MAXRETRA_3NRANK !== '--' && MAXRETRA_3NFSC !== '--') {
          const descConfig = ['回撤较大', '回撤尚可', '回撤较小', '回撤很低'];
          const index = (parseFloat(MAXRETRA_3NRANK) / parseFloat(MAXRETRA_3NFSC));
          if (index <= 0.25) {
            hcrank = 3;
            hcranktip = `${descConfig[hcrank]}`;
          } else if (index <= 0.5 && index > 0.25) {
            hcrank = 2;
            hcranktip = `${descConfig[hcrank]}`;
          } else if (index <= 0.75 && index > 0.5) {
            hcrank = 1;
            hcranktip = `${descConfig[hcrank]}`;
          } else if (index <= 1 && index > 0.75) {
            hcrank = 0;
            hcranktip = `${descConfig[hcrank]}`;
          }
        }

        this.rankList = [
          {
            rank: bdrank,
            content: bdranktip,
          },
          {
            rank: xprank,
            need: true,
            content: xpranktip,
          },
          {
            rank: hcrank,
            content: hcranktip,
          },
        ];
      }
    },
    comfigureRank5n() {
      const fundinfo = StoreManger.getFundTSSJ();
      if (fundinfo) {
        const {
          STDDEV_5NRANK,
          STDDEV_5NFSC,
          SHARP_5NRANK,
          SHARP_5NFSC,
          MAXRETRA_5NRANK,
          MAXRETRA_5NFSC,
        } = fundinfo;

        let bdrank = 5;
        let bdranktip = '';

        let xprank = 5;
        let xpranktip = '';

        let hcrank = 5;
        let hcranktip = '';

        if (STDDEV_5NFSC === '1') {
          bdrank = 3;
          bdranktip = '波动很小';
        }
        if (SHARP_5NFSC === '1') {
          xprank = 3;
          xpranktip = '性价比很高';
        }
        if (MAXRETRA_5NFSC === '1') {
          hcrank = 3;
          hcranktip = '回撤很低';
        }

        if (STDDEV_5NRANK !== '--' && STDDEV_5NFSC !== '--') {
          const descConfig = ['波动较大', '波动尚可', '波动较低', '波动很小'];
          const index = (parseFloat(STDDEV_5NRANK) / parseFloat(STDDEV_5NFSC));
          if (index <= 0.25) {
            bdrank = 3;
            bdranktip = `${descConfig[bdrank]}`;
          } else if (index <= 0.5 && index > 0.25) {
            bdrank = 2;
            bdranktip = `${descConfig[bdrank]}`;
          } else if (index <= 0.75 && index > 0.5) {
            bdrank = 1;
            bdranktip = `${descConfig[bdrank]}`;
          } else if (index <= 1 && index > 0.75) {
            bdrank = 0;
            bdranktip = `${descConfig[bdrank]}`;
          }
        }

        if (SHARP_5NRANK !== '--' && SHARP_5NFSC !== '--') {
          const descConfig = ['性价比较低', '性价比尚可', '性价比较高', '性价比很高'];
          const index = parseFloat(SHARP_5NRANK) / parseFloat(SHARP_5NFSC);
          if (index <= 0.25) {
            xprank = 3;
            xpranktip = `${descConfig[xprank]}`;
          } else if (index <= 0.5 && index > 0.25) {
            xprank = 2;
            xpranktip = `${descConfig[xprank]}`;
          } else if (index <= 0.75 && index > 0.5) {
            xprank = 1;
            xpranktip = `${descConfig[xprank]}`;
          } else if (index <= 1 && index > 0.75) {
            xprank = 0;
            xpranktip = `${descConfig[xprank]}`;
          }
        }

        if (MAXRETRA_5NRANK !== '--' && MAXRETRA_5NFSC !== '--') {
          const descConfig = ['回撤较大', '回撤尚可', '回撤较小', '回撤很低'];
          const index = (parseFloat(MAXRETRA_5NRANK) / parseFloat(MAXRETRA_5NFSC));
          if (index <= 0.25) {
            hcrank = 3;
            hcranktip = `${descConfig[hcrank]}`;
          } else if (index <= 0.5 && index > 0.25) {
            hcrank = 2;
            hcranktip = `${descConfig[hcrank]}`;
          } else if (index <= 0.75 && index > 0.5) {
            hcrank = 1;
            hcranktip = `${descConfig[hcrank]}`;
          } else if (index <= 1 && index > 0.75) {
            hcrank = 0;
            hcranktip = `${descConfig[hcrank]}`;
          }
        }

        this.rankList = [
          {
            rank: bdrank,
            content: bdranktip,
          },
          {
            rank: xprank,
            need: true,
            content: xpranktip,
          },
          {
            rank: hcrank,
            content: hcranktip,
          },
        ];
      }
    },
    comfigureRank() {
      const fundinfo = StoreManger.getFundTSSJ();
      if (fundinfo) {
        const {
          STDDEV_1NRANK,
          STDDEV_1NFSC,
          SHARP_1NRANK,
          SHARP_1NFSC,
          MAXRETRA_1NRANK,
          MAXRETRA_1NFSC,
        } = fundinfo;

        let bdrank = 5;
        let bdranktip = '';

        let xprank = 5;
        let xpranktip = '';

        let hcrank = 5;
        let hcranktip = '';

        if (STDDEV_1NFSC === '1') {
          bdrank = 3;
          bdranktip = '波动很小';
        }
        if (SHARP_1NFSC === '1') {
          xprank = 3;
          xpranktip = '性价比很高';
        }
        if (MAXRETRA_1NFSC === '1') {
          hcrank = 3;
          hcranktip = '回撤很低';
        }

        if (STDDEV_1NRANK !== '--' && STDDEV_1NFSC !== '--') {
          const descConfig = ['波动较大', '波动尚可', '波动较低', '波动很小'];
          const index = (parseFloat(STDDEV_1NRANK) / parseFloat(STDDEV_1NFSC));
          if (index <= 0.25) {
            bdrank = 3;
            bdranktip = `${descConfig[bdrank]}`;
          } else if (index <= 0.5 && index > 0.25) {
            bdrank = 2;
            bdranktip = `${descConfig[bdrank]}`;
          } else if (index <= 0.75 && index > 0.5) {
            bdrank = 1;
            bdranktip = `${descConfig[bdrank]}`;
          } else if (index <= 1 && index > 0.75) {
            bdrank = 0;
            bdranktip = `${descConfig[bdrank]}`;
          }
        }

        if (SHARP_1NRANK !== '--' && SHARP_1NFSC !== '--') {
          const descConfig = ['性价比较低', '性价比尚可', '性价比较高', '性价比很高'];
          const index = parseFloat(SHARP_1NRANK) / parseFloat(SHARP_1NFSC);
          if (index <= 0.25) {
            xprank = 3;
            xpranktip = `${descConfig[xprank]}`;
          } else if (index <= 0.5 && index > 0.25) {
            xprank = 2;
            xpranktip = `${descConfig[xprank]}`;
          } else if (index <= 0.75 && index > 0.5) {
            xprank = 1;
            xpranktip = `${descConfig[xprank]}`;
          } else if (index <= 1 && index > 0.75) {
            xprank = 0;
            xpranktip = `${descConfig[xprank]}`;
          }
        }

        if (MAXRETRA_1NRANK !== '--' && MAXRETRA_1NFSC !== '--') {
          const descConfig = ['回撤较大', '回撤尚可', '回撤较小', '回撤很低'];
          const index = (parseFloat(MAXRETRA_1NRANK) / parseFloat(MAXRETRA_1NFSC));
          if (index <= 0.25) {
            hcrank = 3;
            hcranktip = `${descConfig[hcrank]}`;
          } else if (index <= 0.5 && index > 0.25) {
            hcrank = 2;
            hcranktip = `${descConfig[hcrank]}`;
          } else if (index <= 0.75 && index > 0.5) {
            hcrank = 1;
            hcranktip = `${descConfig[hcrank]}`;
          } else if (index <= 1 && index > 0.75) {
            hcrank = 0;
            hcranktip = `${descConfig[hcrank]}`;
          }
        }

        this.rankList = [
          {
            rank: bdrank,
            content: bdranktip,
          },
          {
            rank: xprank,
            need: true,
            content: xpranktip,
          },
          {
            rank: hcrank,
            content: hcranktip,
          },
        ];
      }
    },
    getMainQueryError() {
      const fundinfo = StoreManger.getFundJJXQ();
      if (!fundinfo) {
        return true;
      }
      if (!fundinfo.FCODE) {
        return true;
      }
      return false;
    },
    fetchCache() {
      const fundinfo = StoreManger.getFundTSSJ();
      if (this.typeIndex === 1) {
        this.mainlist = this.handleData3n(fundinfo);
      } else if (this.typeIndex === 2) {
        this.mainlist = this.handleData5n(fundinfo);
      } else {
        this.mainlist = this.handleData(fundinfo);
      }
    },
    fetchRequest() {
      return new Promise((resolve, reject) => {
        reject();
      });
    },
    checkData() {
      return true;
    },
    handleData3n(item) {
      this.ShowEmpty = false;
      const basicData = {};
      const fetch = (key) => {
        const res = JSTool.fetchString(item, key);
        return res || '--';
      };
      // eslint-disable-next-line no-use-before-define
      const STDDEV1 = fetch('STDDEV3') === '--' ? '--' : `${numeral(fetch('STDDEV3')).format('0.00%')}`;
      const SHARP1 = fetch('SHARP3') === '--' ? '--' : `${numeral(fetch('SHARP3')).format('0.00')}`;
      const MAXRETRA1 = fetch('MAXRETRA3') === '--' ? '--' : `${numeral(fetch('MAXRETRA3')).format('0.00%')}`;

      basicData.STDDEV1 = STDDEV1;
      basicData.SHARP1 = SHARP1;
      basicData.MAXRETRA1 = MAXRETRA1;
      if (STDDEV1 === '--') {
        if (SHARP1 === '--') {
          if (MAXRETRA1 === '--') {
            this.ShowEmpty = true;
          }
        }
      }
      return [
        {
          value: basicData.STDDEV1,
          text: '波动率',
        },
        {
          value: basicData.SHARP1,
          text: '夏普比率',
        },
        {
          value: basicData.MAXRETRA1,
          text: '最大回撤',
        },
      ];
    },
    handleData5n(item) {
      this.ShowEmpty = false;
      const basicData = {};
      const fetch = (key) => {
        const res = JSTool.fetchString(item, key);
        return res || '--';
      };
      // eslint-disable-next-line no-use-before-define
      const STDDEV1 = fetch('STDDEV5') === '--' ? '--' : `${numeral(fetch('STDDEV5')).format('0.00%')}`;
      const SHARP1 = fetch('SHARP5') === '--' ? '--' : `${numeral(fetch('SHARP5')).format('0.00')}`;
      const MAXRETRA1 = fetch('MAXRETRA5') === '--' ? '--' : `${numeral(fetch('MAXRETRA5')).format('0.00%')}`;

      basicData.STDDEV1 = STDDEV1;
      basicData.SHARP1 = SHARP1;
      basicData.MAXRETRA1 = MAXRETRA1;
      if (STDDEV1 === '--') {
        if (SHARP1 === '--') {
          if (MAXRETRA1 === '--') {
            this.ShowEmpty = true;
          }
        }
      }
      return [
        {
          value: basicData.STDDEV1,
          text: '波动率',
        },
        {
          value: basicData.SHARP1,
          text: '夏普比率',
        },
        {
          value: basicData.MAXRETRA1,
          text: '最大回撤',
        },
      ];
    },
    handleData(item) {
      this.ShowEmpty = false;
      const basicData = {};
      const fetch = (key) => {
        const res = JSTool.fetchString(item, key);
        return res || '--';
      };
      // eslint-disable-next-line no-use-before-define
      const STDDEV1 = fetch('STDDEV1') === '--' ? '--' : `${numeral(fetch('STDDEV1')).format('0.00%')}`;
      const SHARP1 = fetch('SHARP1') === '--' ? '--' : `${numeral(fetch('SHARP1')).format('0.00')}`;
      const MAXRETRA1 = fetch('MAXRETRA1') === '--' ? '--' : `${numeral(fetch('MAXRETRA1')).format('0.00%')}`;

      basicData.STDDEV1 = STDDEV1;
      basicData.SHARP1 = SHARP1;
      basicData.MAXRETRA1 = MAXRETRA1;
      if (STDDEV1 === '--') {
        if (SHARP1 === '--') {
          if (MAXRETRA1 === '--') {
            this.isTs = false;
          }
        }
      }
      return [
        {
          value: basicData.STDDEV1,
          text: '波动率',
        },
        {
          value: basicData.SHARP1,
          text: '夏普比率',
        },
        {
          value: basicData.MAXRETRA1,
          text: '最大回撤',
        },
      ];
    },
    // eslint-disable-next-line
    throttleclickTSSJ:throttle (
      function throttleclickTSSJ() {
        this.clickTSSJ();
      },
      1000,
      { trailing: false },
    ),
    clickTSSJ() {
      let canAlert = false;
      canAlert = false;
      // #if EXECUTION_ENV === 'fund'
      // eslint-disable-next-line no-undef
      const systemInfo = fund.getSystemInfoSync();
      if (systemInfo) {
        if (systemInfo.version) {
          if (systemInfo.version >= '6.4.1') {
            // eslint-disable-next-line no-undef
            if (fund.presentPage) {
              canAlert = true;
            }
          }
        }
      }
      // #endif
      // #if EXECUTION_ENV === 'web'
      canAlert = false;
      // #endif
      if (!canAlert) {
        const content = '特色数据均采用最新同类分类排名，如波动率只表示本基金在最新分类中的波动率大小程度。\n夏普比率:表示每承受一单位风险，预期可以拿到多少超额收益。指标越大则基金性价比越高。\n波动率:表示收益率变化程度的指标，更直观地表述就是风险。指标越小则基金风险越低。\n最大回撤:表示基金净值从最高到最低的下降幅度。指标越小则基金风险控制能力越好。';
        this.$feedback.showModal({
          title: '特色数据',
          content,
          showCancel: false,
          confirmText: '知道了',
          confirmColor: '#ff4400',
        });
      } else {
        // eslint-disable-next-line no-undef
        fund.presentPage({
          appId: 'f67a50bbe71a4b41a93eb2274e2a95d0',
          url: '/pages/index/index',
          navigationBarDisplay: false,
          animation: false,
        });
      }
    },
    updateChart(key, value) {
      console.log(`${key} ---- ${value}`);
      this[key] = value;
      let ename = 'pzy.tssj.j1n.click';
      const fundinfo = StoreManger.getFundTSSJ();
      if (this.typeIndex === 1) {
        ename = 'pzy.tssj.j3n.click';
        this.mainlist = this.handleData3n(fundinfo);
        this.comfigureRank3n();
      } else if (this.typeIndex === 2) {
        ename = 'pzy.tssj.j5n.click';
        this.mainlist = this.handleData5n(fundinfo);
        this.comfigureRank5n();
      } else {
        this.mainlist = this.handleData(fundinfo);
        this.comfigureRank();
      }
      this.reportMonitor({
        eventName: ename,
      });
    },
    clickMore() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      detailPushPage({
        appId: '968d3d05d66149939aef736473653eeb',
        url: '/pages/FundData',
        params: {
          fundcode: this.fundCode,
          fundname: name,
        },
      }, {
        // 第二个参数为h5页面跳转非项目内的页面参数
        url: '',
        wxmp: {
          url: `/pages/fund-detail/characteristic-data?id=${this.fundCode}`,
          openNewWindow: true,
        },
      });
      this.reportMonitor({
        eventName: 'pz.xx.jjsj.more',
      });
    },
  },
};
</script>

<style scoped lang="less">
  .ts-mid-tag{
    background: #fff;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .tabs-ts-mid-item-text{
    border-bottom: 4px solid transparent;
    line-height: normal;
    display: flex;
    justify-content: center;
    flex: 1;
  }
  .ts-tabs-mid-wrapper{
    background-color: #f5f5f5;
    display: flex;
    justify-content: center;
    flex: 1;
    width: 459px;
    margin: 0 auto;
    border-radius: 12px;
    .tab {
      display: flex;
      font-size: 28px;
      color: #333;
      letter-spacing: 0;
      text-align: center;
      line-height: normal;
      height: 50px;
      width: 152px;
      background: #f5f5f5;
      margin: 4px;
      border-radius: 8px;
      align-items: center;
      justify-content: center;
    }
    .stab {
      display: flex;
      font-weight: bold;
      font-size: 28px;
      color: #333;
      letter-spacing: 0;
      text-align: center;
      line-height: normal;
      height: 50px;
      width: 152px;
      background: #ffffff;
      margin: 4px;
      border-radius: 8px;
      align-items: center;
      justify-content: center;
    }
  }
 .title-wrapper {
    background-color: #ffffff;
    height: 90px;
    margin: 0px 0px;
    margin-top: 0px;
    margin-left: 24px;
    margin-right: 18px;
    padding-top: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
.title-text{
  font-weight: bold;
  font-size: 36px;
  color: #000000;
  line-height: 36px;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.subtitle-t{
  font-weight: normal;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #666666;
  margin-left: 8px;
  margin-right: 8px;
}
.desc-r{
    font-size: 28px;
    color: #666666;
    line-height: normal;
    text-align: right;
    margin-left: 24px;
    flex: 1;
}
.mianv{
  margin-left: 24px;
  margin-right: 24px;
  padding-bottom: 10px;
  margin-bottom: 24px;
  background: #fff;
  border-radius: 12px;
  position: relative;
}
.data-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: white;
  margin-left: 30px;
  margin-right: 30px;
  margin-top: 10px;
}
.leftv {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: white;
  width: 30%;
}
.rightv{
  width: 70%;
}
.item-bac{
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  flex: 1;
}
.item-wrapper {
  display: flex;
  flex: 1;
  flex-direction: row;
}

.item-value {
  font-family: DINAlternate-Bold;
font-size: 40px;
color: #000000;
line-height: 40px;
margin-bottom: 16px;
margin-top: 16px;
}

.item-text {
  font-size: 28px;
color: #666666;
line-height: 28px;
margin-right: 10px;
}
.warn-tip-gray-gx {
    width: 26px;
    height: 26px;
    vertical-align: middle;
    position: relative;
  }
.rank_a{
    width: 20px;
    height: 17px;
    margin-bottom: 10px;
}
  .item-rank{
    position: relative;
    display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: white;
  }
  .rank-view {
    display: flex;
    flex-direction: column;
    background-color: white;
    justify-content: center;
    align-items: center;
    flex: 1;
    margin-top: 16px;
    margin-bottom: 30px;
    position: relative;
  }
  .rank-line{
    background: #EEEEEE;
    border-radius: 100px 0 0 100px;
    height: 12px;
    width: 95%;
    margin-left: 6px;
    margin-bottom: 6px;
  }
  .rank-line-r{
    background: #FF6434;
    border-radius: 100px 0 0 100px;
    height: 12px;
    width: 95%;
    margin-left: 6px;
    margin-bottom: 6px;
  }
  .rank-arr{
    display: flex;
    flex-direction: column;
    background-color: white;
    justify-content: center;
    align-items: center;
    flex: 1;
  }
  .itemClass{
    width: 25%;
  }
  .rank-cont-w{
    font-size: 28px;
    color: #ffffff;
    line-height: 28px;
    margin-bottom: 10px;
    width: 100%;
  }
  .rank-cont-ab{
    left: -10px;
    top: 0;
    position: absolute;
    font-size: 28px;
    color: #000000;
    line-height: 28px;
    margin-bottom: 10px;
    width: 108px;
    text-align: center;
    white-space:nowrap;
    z-index: 9;
  }
  .rank-cont{
    font-size: 28px;
    color: #000000;
    line-height: 28px;
    margin-bottom: 10px;
    width: 108px;
    text-align: center;
    white-space:nowrap;
    position: absolute;
    left: 0px;
    top: 0;
    z-index: 9;
  }
  .norankdata{
    position: absolute;
    left: 0;
    top: 16px;
    width: 168px;
    font-family: PingFangSC-Regular;
    font-size: 28px;
    color: #999999;
    z-index: 99;
  }
  .ts-text {
    height: 40px;
    width: 100%;
    font-family: PingFangSC-Regular;
    font-size: 30px;
    color: #999999;
    text-align: center;
}
.ts-empty {
  position:absolute;
  bottom: 0;
  height: 390px;
  width: 100%;
  z-index: 99;
  background: #fff;
  border-radius: 12px;
  align-items: center;
  justify-content: center;
  display: flex;
}
</style>
